'use strict';

// The aim of this file is to link tag filters with other elements on the same page in a reusable and flexible way
// For now it is integrated with:
// - Masonry Grids, they will react to filter changes if they have the class: .Masonry--filterable
// - Links, they will react to filter changes: if a link has the class: .Link--filterable, its URL will be updated with a query string

var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  utils = require('../utilities'),
  MasonryGridView = require('../../components/MasonryGridView/MasonryGridView').default,
  TagFilterView = require('./TagFilterView'),

  FilteredPageView = Backbone.View.extend({

    initialize: function(options) {
    // Create tag filter view
      this.tagFilter = new TagFilterView({
        el: options.$tagFilter
      });
    },

    // Plug a See All element to the filters
    addLink: function($link) {

      // Set initial see all url with filters
      this.setLinkUrl($link, {
        filterId: this.tagFilter.filterId,
        tagId: this.tagFilter.tagIds
      });

      // When a filter change, set a new url on see all
      this.tagFilter.on('change', _.bind(function(changed, filter, tags) {
        this.setLinkUrl($link, {
          filterId: filter,
          tagId: tags
        });
      }, this));

    },

    setLinkUrl: function($link, params) {
      // Get See All URL without parameters already set
      var linkUrl = $link.attr('href').split('?')[0];

      // Update See All Url with query string
      $link.attr('href', utils.queryStringUrl(linkUrl, params));
    },

    // Plug a Masonry grid to the filters
    addMasonryGrid: function(grid) {

      var masonryGridView = new MasonryGridView({
        el: grid,
        ajaxParams: {
          filterId: this.tagFilter.filterId,
          tagId: this.tagFilter.tagIds
        }
      });

      // When the filter change, refresh the content grids the page contains a tag filter element
      this.tagFilter.on('change', function(changed, filter, tags) {
        masonryGridView.ajaxRefresh({
          filterId: filter,
          tagId: tags
        });
      });
    }

  }, {
    create: function($parent) {
      var $tagFilter = $parent.find('.TagFilter');

      if ($tagFilter.length) {
        var filteredPage = new FilteredPageView({
          $tagFilter: $tagFilter
        });

        $parent.find('.Link--filterable').each(function() {
          filteredPage.addLink($(this));
        });

        $parent.find('.Masonry--filterable').each(function() {
          filteredPage.addMasonryGrid(this);
        });
      } else {
        // Need to create Masonry grids even if a tag filter is not on the page
        $parent.find('.Masonry--filterable').each(function() {
          new MasonryGridView({
            el: this
          });
        });
      }
    }
  });

module.exports = FilteredPageView;



// WEBPACK FOOTER //
// ./assets/js/components/FilteredPageView.js